import * as React from "react";
import Wait from "../../wait";
import {ProjectsService} from "../../../service/v1/projects";
import PopDetail from "../../popdetail";
import CCROChangePartyPicturePane from "../../add/ccro_change_party_picture";
import UpdateService from "../../../service/update";
import baseUrl from "./../../../service/baseURL";

export default class PartyInfo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            stage: 1,
            data: [],
        }
        this.loadData = this.loadData.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.handleChangeFile = this.handleChangeFile.bind(this)
    }

    // Check if user has edit permissions (LO or Admin roles)
    canEdit() {
        const userGroup = sessionStorage.getItem('user_groups');
        return userGroup === 'LO' || userGroup === 'Admin' || userGroup === 'ADMIN';
    }

    componentDidMount() {
        this.loadData()
    }


    handleChangeFile=(e,d,field)=>{

        const formData = new FormData()
        formData.append('picture',e.target.files[0])

        let party_id = d.id
        let extra = {
            party_id:party_id,
            field:field
        }
        formData.append('extra',JSON.stringify(extra))

        try {
            Wait.show('Updating...')
            UpdateService.updatePartyPicture(formData).then(r=>{
                Wait.dismiss()
                console.log(r.data)
            })
        }catch (e) {
            console.log(e)
        }

    }

    handleChanges(e,d,field){
        // Check if user has edit permissions
        if (!this.canEdit()) {
            console.log('User does not have edit permissions');
            return;
        }

        let party_id = d.id
        let value = e.target.value

        console.log('Sending update:', { party_id, field, value })

        try {
            Wait.show('Updating...')
            UpdateService.updateParty({
                party_id:party_id,
                field:field,
                value:value
            }).then(r=>{
                Wait.dismiss()
                console.log('Update response:', r.data)
                if (r.data.status === 0) {
                    console.error('Update failed:', r.data.message)
                } else {
                    console.log('Update successful')
                }
            }).catch(error => {
                Wait.dismiss()
                console.error('Update error:', error)
            })
        }catch (e) {
            Wait.dismiss()
            console.log('Handle changes error:', e)
        }
    }

    loadData() {
        try {
            Wait.show("Fetching Party Info....")
            ProjectsService.fetchPartyInfo(this.props.parcel.id).then(r => {
                Wait.dismiss()
                try {
                    console.log(r.data.results)
                    this.setState({
                        data: r.data.results
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            Wait.dismiss();
            console.log(e)
        }
    }


    render() {
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        const card = {
            background: '#fff',
            borderRadius: 10,
            boxShadow: '0 4px 12px rgba(57,93,154,0.10)',
            padding: '20px',
            marginBottom: '24px',
            border: '1px solid #e0e7ef',
            maxWidth: 700,
            marginLeft: 'auto',
            marginRight: 'auto',
            fontFamily
        };
        const caption = {
            fontSize: 16,
            fontWeight: 700,
            color: '#fff',
            background: 'linear-gradient(90deg, #395d9a 0%, #2bbbad 100%)',
            padding: '8px 16px',
            borderRadius: 6,
            marginBottom: 18,
            display: 'inline-block',
            boxShadow: '0 2px 8px rgba(57,93,154,0.07)'
        };
        const imgBox = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 16,
            gap: 8
        };
        const imgStyle = {
            width: '100%',
            maxWidth: 260,
            height: 'auto',
            borderRadius: 8,
            objectFit: 'cover',
            boxShadow: '0 2px 8px rgba(57,93,154,0.10)'
        };
        const btn = {
            background: 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)',
            color: 'white',
            border: 'none',
            borderRadius: 0,
            padding: '6px 12px',
            fontWeight: 600,
            fontSize: 13,
            cursor: 'pointer',
            fontFamily,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            minWidth: 'auto'
        };
        const label = {
            fontWeight: 600,
            color: '#395d9a',
            fontSize: 14,
            marginBottom: 4
        };
        const input = {
            width: '100%',
            padding: '8px 12px',
            border: '1px solid #e0e7ef',
            borderRadius: 0,
            fontSize: 14,
            background: '#f8f9fa',
            color: '#333',
            marginBottom: 8
        };
        const detailsGrid = {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 16,
            marginBottom: 12
        };
        const partyGrid = {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: 32,
            alignItems: 'flex-start',
            marginBottom: 12
        };
        const partyGridMobile = {
            display: 'block'
        };
        const outer = {
            width: '100%',
            minHeight: '40vh',
            maxHeight: '60vh',
            padding: '0',
            background: '#f6f8fa',
            overflowY: 'auto',
            fontFamily
        };
        
        const permissionNotice = {
            background: 'linear-gradient(90deg, #f39c12 0%, #e67e22 100%)',
            color: 'white',
            padding: '8px 16px',
            borderRadius: 6,
            fontSize: 13,
            fontWeight: 600,
            marginBottom: 16,
            textAlign: 'center',
            boxShadow: '0 2px 8px rgba(243,156,18,0.15)'
        };
        
        // Responsive grid: use partyGridMobile if window width < 900px
        const isMobile = typeof window !== 'undefined' && window.innerWidth < 900;
                return (
            <div style={outer}>
                {!this.canEdit() && (
                    <div style={permissionNotice}>
                        <span className={'fa fa-lock'} style={{marginRight: 8}}/>
                        Read-only mode: Only Land Officers and Administrators can edit party information
                    </div>
                )}
                {this.state.data.map((d, i) => (
                    <div style={card} key={i}>
                        <div style={isMobile ? partyGridMobile : partyGrid}>
                            <div style={{gridColumn: '1 / 2'}}>
                                <div style={imgBox}>
                                    <img src={baseUrl().split("/api")[0] + d.picture} style={imgStyle} alt="Party"/>
                                    <input type={'file'} accept={".png,.PNG,.jpg,.JPG,.jpeg,.JPEG"}
                                       name={'sign'} onChange={(e)=>this.handleChangeFile(e,d,'picture')}/>
                                    <button style={btn} onClick={()=>PopDetail.show('Change Picture',
                                                <CCROChangePartyPicturePane party={d} task_id={this.props.taskId} screen_code={this.props.screen_code}
                                                                            loadData={()=>this.loadData()} key={new Date()}/>,40)}>
                                        <span className={'fa fa-picture-o'}/>Change Picture
                                    </button>
                                </div>
                            </div>
                            <div style={{gridColumn: isMobile ? 'auto' : '2 / 4'}}>
                                <div style={detailsGrid}>
                                    <div>
                                        <div style={label}>First Name</div>
                                        <input type={'text'} defaultValue={d.first_name} style={input} 
                                               readOnly={!this.canEdit()} 
                                               onChange={(e)=>this.handleChanges(e,d,'first_name')}/>
                                    </div>
                                    <div>
                                        <div style={label}>Middle Name</div>
                                        <input type={'text'} defaultValue={d.middle_name} style={input} 
                                               readOnly={!this.canEdit()} 
                                               onChange={(e)=>this.handleChanges(e,d,'middle_name')}/>
                                    </div>
                                    <div>
                                        <div style={label}>Last Name</div>
                                        <input type={'text'} defaultValue={d.last_name} style={input} 
                                               readOnly={!this.canEdit()} 
                                               onChange={(e)=>this.handleChanges(e,d,'last_name')}/>
                                    </div>
                                    <div>
                                        <div style={label}>Gender</div>
                                        <input type={'text'} defaultValue={d.gender} style={input} 
                                               readOnly={!this.canEdit()} 
                                               onChange={(e)=>this.handleChanges(e,d,'gender')}/>
                                    </div>
                                    <div>
                                        <div style={label}>Date Of Birth</div>
                                        <input type={'date'} defaultValue={d.dob} style={input} 
                                               readOnly={!this.canEdit()} 
                                               onChange={(e)=>this.handleChanges(e,d,'dob')}/>
                                    </div>
                                    <div>
                                        <div style={label}>Citizenship</div>
                                        <input type={'text'} readOnly={true} defaultValue={d.citizenship_status} style={input}/>
                                    </div>
                                    <div>
                                        <div style={label}>Id Type</div>
                                        <input type={'text'} readOnly={true} defaultValue={d.id_type} style={input}/>
                                    </div>
                                    <div>
                                        <div style={label}>Id No.</div>
                                        <input type={'text'} defaultValue={d.id_no} style={input} 
                                               readOnly={!this.canEdit()} 
                                               onChange={(e)=>this.handleChanges(e,d,'id_no')}/>
                                    </div>
                                    <div>
                                        <div style={label}>Role Name</div>
                                        <input type={'text'} readOnly={true} defaultValue={d.role_name} style={input}/>
                                    </div>
                                    <div>
                                        <div style={label}>Phone</div>
                                        <input type={'text'} defaultValue={d.phone} style={input} 
                                               readOnly={!this.canEdit()} 
                                               onChange={(e)=>this.handleChanges(e,d,'phone')}/>
                                    </div>
                                    <div>
                                        <div style={label}>Email</div>
                                        <input type={'text'} readOnly={true} defaultValue={d.email} style={input}/>
                                    </div>
                                    <div>
                                        <div style={label}>Address</div>
                                        <input type={'text'} readOnly={true} defaultValue={d.address} style={input}/>
                                    </div>
                                    <div>
                                        <div style={label}>Acquisition</div>
                                        <input type={'text'} readOnly={true} defaultValue={d.acquire} style={input}/>
                                    </div>
                                    <div>
                                        <div style={label}>Marital Status</div>
                                        <input type={'text'} readOnly={true} defaultValue={d.marital_status} style={input}/>
                                    </div>
                                    <div>
                                        <div style={label}>Disability</div>
                                        <input type={'text'} defaultValue={d.disability} style={input} 
                                               readOnly={!this.canEdit()} 
                                               onChange={(e)=>this.handleChanges(e,d,'disability')}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

